import {lookbackRange} from './lead-chart-model';

export const qualityGroups=['legitimate','spam','solicitation','not_a_lead','no_details','needs_review'] as const;
export type QualityGroup=typeof qualityGroups[number];
export const qualityLabels:Record<QualityGroup,string>={legitimate:'Legitimate leads',spam:'Spam',solicitation:'Solicitation',not_a_lead:'Not a lead',no_details:'No details',needs_review:'Needs review'};
/** What each lead type holds, in a sentence. */
export const qualityHelp:Record<QualityGroup,string>={
 legitimate:'Someone asking for a service.',
 spam:'Scams, bots and numbers blocked as spam.',
 solicitation:'Telemarketers, robocalls and sales pitches.',
 not_a_lead:'Wrong numbers, existing customers, job seekers and tests.',
 no_details:'Hang-ups, calls where nobody spoke, and old records with nothing recorded.',
 needs_review:'Only what is genuinely unclear. It is reviewed every day.'};
export type LeadQualityData={
 counts:Partial<Record<QualityGroup,number>>;
 days:Array<{day:string;legitimate:number}>;
 start_date:string;end_date:string;timezone:string;date_basis:'first_contact';
};
export function initialQualityGroups(params:URLSearchParams):QualityGroup[]{
 if(params.has('inq_quality'))return qualityGroups.filter(g=>params.get('inq_quality')!.split(',').includes(g));
 const legacy=params.get('inq_intent');
 if(legacy==='spam'||legacy==='likely_spam')return ['spam'];
 if(legacy==='telemarketing'||legacy==='likely_telemarketing')return ['solicitation'];
 if(legacy&&legacy!=='potential_lead')return ['needs_review'];
 return ['legitimate'];
}
export function initialInquiryRange(params:URLSearchParams,today?:string):[string,string]{
 if(params.has('inq_start')||params.has('inq_end'))return [params.get('inq_start')||'',params.get('inq_end')||''];
 return lookbackRange(params.get('inq_range')==='all'?'all':'30',today);
}
export function toggleQualityGroup(selected:QualityGroup[],group:QualityGroup):QualityGroup[]{
 return qualityGroups.filter(g=>g===group?!selected.includes(g):selected.includes(g));
}
export function legitimateDailyAverage(data:LeadQualityData):number{
 return data.days.length?data.days.reduce((sum,d)=>sum+d.legitimate,0)/data.days.length:0;
}
export function qualityDayWindow(data:LeadQualityData,offset:number,size=31){
 const end=Math.max(0,data.days.length-Math.max(0,offset));
 return data.days.slice(Math.max(0,end-size),end);
}
